import { memo } from "react"
import { Box, Typography } from "@mui/material"
import { KeyboardArrowLeft } from "@mui/icons-material"
import PropTypes from "prop-types"
import ContributorsTableTooltip from "renderers/contributors-table/tooltip"
import AggregationTableDropdown from "../aggregation-table-dropdown"
import LabelCellContent from "./label-cell-content"

const LabelCell = memo(({
  params,
  handleClickContributor,
  includeDrilldownArrows,
  isTopLevel,
  handleSetTableLevel,
  dropdownTableTitle,
  parentLevelOptions,
  currentGroupId,
}) => {
  const { contributor, isAggregation, label } = params?.row || {}

  if (isAggregation) {
    return (
      <Box className="label-cell label-cell-aggregation">
        {isTopLevel ? (
          <Typography variant="body2" className="label-cell-typography">
            {label}
          </Typography>
        ) : (
          <Box className="label-cell-drill-down drill-down-link">
            <a onClick={() => handleSetTableLevel(null)} className="back-button">
              <KeyboardArrowLeft />
            </a>
            <AggregationTableDropdown
              selectedItemId={currentGroupId || ""}
              parentLevelOptions={parentLevelOptions || {}}
              dropdownTableTitle={dropdownTableTitle || "Groups"}
              label={label}
              onItemClick={(itemId, replaceLastSelectedItem) => handleSetTableLevel(itemId, replaceLastSelectedItem)}
            />
          </Box>
        )}
      </Box>
    )
  }

  // Regular contributor cell with tooltip
  return (
    <Box className="label-cell">
      <ContributorsTableTooltip item={contributor}>
        <LabelCellContent
          contributor={contributor}
          handleClickContributor={handleClickContributor}
          includeDrilldownArrows={includeDrilldownArrows}
        />
      </ContributorsTableTooltip>
    </Box>
  )
})

LabelCell.displayName = "LabelCell"

LabelCell.propTypes = {
  params: PropTypes.shape({
    row: PropTypes.shape({
      contributor: PropTypes.object,
      isAggregation: PropTypes.bool,
      label: PropTypes.string,
    }).isRequired,
  }).isRequired,
  handleClickContributor: PropTypes.func.isRequired,
  includeDrilldownArrows: PropTypes.bool,
  isTopLevel: PropTypes.bool.isRequired,
  handleSetTableLevel: PropTypes.func.isRequired,
  dropdownTableTitle: PropTypes.string,
  parentLevelOptions: PropTypes.array,
  currentGroupId: PropTypes.string,
}

export default LabelCell
